import React from 'react';
import {useDispatch} from 'react-redux';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import {dispatchAsync} from 'redux/common';
import {asyncType} from 'redux/helpers';

/**
 *
 * @param defaultVal
 * @param url
 * @param type
 * @returns [item: T, refresh: Function]
 */
export function useGetApiDispatch<T>(
   defaultVal: T,
   url: string,
   type: ReturnType<typeof asyncType>
): [T, () => void] {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const [item, setItem] = React.useState<T>(defaultVal);

   const [refreshTrigger, refresh] = React.useState(false);
   const forceUpdate = React.useCallback(() => refresh(!refreshTrigger), [refresh, refreshTrigger]);

   React.useEffect(() => {
      dispatch(
         dispatchAsync(url, type, {
            onSuccess: (item: T) => {
               if (isMountedRef.current) {
                  setItem(item);
               }
            },
         })
      );
   }, [refreshTrigger, isMountedRef, dispatch, url, type]);

   return [item, forceUpdate];
}
